import { useTranslation } from 'react-i18next'
import { AddRepairOrder } from '~/features/RepairOrders/AddRepairOrder'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import {
  QuickNavigation,
  QuickNavigationOptions,
} from '~/shared/ui/QuickNavigation'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'repair orders', link: '/repair-orders' },
  { titleI18n: 'create repair order' },
]

const quickNavigationOptions: QuickNavigationOptions = [
  { labelI18n: 'form.car', anchor: 'car' },
  { labelI18n: 'form.description repair', anchor: 'descriptionRepair' },
  { labelI18n: 'form.sto', anchor: 'sto' },
  { labelI18n: 'form.cost', anchor: 'cost' },
  { labelI18n: 'form.files', anchor: 'files' },
]

export const AddRepairOrderPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('create repair order')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('create repair order')}</PageTitle>
      </Container>

      <AddRepairOrder />

      <QuickNavigation options={quickNavigationOptions} />
    </PageContainer>
  )
}
